import React, { Fragment } from 'react'
//import styled from 'styled-components'
import messages from '@App/session/messages'
import { useIntl } from 'react-intl'
import { sharedMessages as commonMessages } from '@Locales/index'
import TextInput from '@Components/TextInput'
import { HelperText, SignInFormButton, Warning } from '../../index'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'

type props = {
  emailAddress: string
  badEmailError: boolean
  emptyEmailError: boolean
  handleEmailSubmit: () => void
  handleSetEmailAddress: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const RequestEmail = (props: props) => {
  const intl = useIntl()
  const { emailAddress, badEmailError, emptyEmailError, handleEmailSubmit, handleSetEmailAddress } =
    props

  return (
    <Fragment>
      {badEmailError ? (
        <Warning>
          <HubFormattedMessage {...commonMessages.badEmailError} />
        </Warning>
      ) : emptyEmailError ? (
        <Warning>
          <HubFormattedMessage {...commonMessages.emptyEmailError} />
        </Warning>
      ) : (
        <HelperText>
          <HubFormattedMessage {...messages.hubEmailFormInstruction} />
        </HelperText>
      )}
      <TextInput
        aria-label={intl ? intl.formatMessage(commonMessages.email) : ''}
        placeholder={intl ? intl.formatMessage(commonMessages.email) : ''}
        name="email"
        label={'email'}
        value={emailAddress}
        onChange={handleSetEmailAddress}
        required
        autoFocus
      />
      <SignInFormButton displayType="primary" onClick={() => handleEmailSubmit()}>
        <HubFormattedMessage {...commonMessages.continue} />
      </SignInFormButton>
    </Fragment>
  )
}

export default RequestEmail
